import React, { Component, Fragment } from "react";
import MyClubsList from "../../../golfers/components/MyClubs/MyClubs";
import { sortByLastName } from "../../../../shared/helpers/api-helper-b";
import GolfersListItem from "./GolfersListItem";
import { Helmet } from "react-helmet";
import {
  H_CALC_MY_CLUBS_TITLE,
  H_CALC_MY_CLUBS_DESC,
} from "../../../../shared/variables/meta-seo";

class MyClubs extends Component {
  renderItem = (golfer, key) => <GolfersListItem key={key} golfer={golfer} />;

  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{H_CALC_MY_CLUBS_TITLE}</title>
          <meta name="description" content={H_CALC_MY_CLUBS_DESC} />
        </Helmet>
        <MyClubsList
          renderItem={this.renderItem}
          sortCriteria={sortByLastName}
        />
      </Fragment>
    );
  }
}

export default MyClubs;
